export const removedCountries = [
  'Antarctica',
  'New Zealand',
  'Fiji',
  'Philippines',
  'Chile',
  'Fr. Polynesia',
  'Kiribati',
  'Vanuatu',
  'Solomon Is.',
  'Marshall Is.',
  'Tonga',
  'New Caledonia',
  'Nauru',
  'Micronesia',
  'Palau',
  'Taiwan',
  'Japan',
  'American Samoa',
  'Mauritius',
  'Seychelles',
  'Maldives',
  'São Tomé and Principe',
  'Iceland',
  'Sri Lanka',
  'Taiwan',
];
